"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validBaseUrlMatches = exports.getUrlQueryParam = exports.getTLD = exports.getIscAndItc = exports.getImagesBaseUrl = exports.getEnv = exports.alternateResellerBaseUrls = void 0;
const alternateResellerBaseUrls = exports.alternateResellerBaseUrls = ['secureserver\\.net', '123-reg\\.co\\.uk'];
const validBaseUrlMatches = exports.validBaseUrlMatches = ['godaddy\\.com', ...alternateResellerBaseUrls];
const validHostMatches = {
  dev: validBaseUrlMatches.map(url => `dev-${url}`),
  test: validBaseUrlMatches.map(url => `test-${url}`),
  prod: validBaseUrlMatches
};

/**
 * @method getEnv
 * @param {String} host Example: godaddy.com or secureserver.net
 * @returns {String} Returns env
 */
const getEnv = host => {
  for (const key of Object.keys(validHostMatches)) {
    for (const urlMatch of validHostMatches[key]) {
      const urlRegex = new RegExp(urlMatch, 'i');
      if (urlRegex.test(host)) {
        return key;
      }
    }
  }
  return 'prod';
};

/**
 * @method getIscAndItc
 * @param  {String} trackingCode default trackingCode
 * @returns {Object} {{isc: string, itc: string}}
 */
exports.getEnv = getEnv;
const getIscAndItc = (trackingCode = '') => {
  const queryParams = new URLSearchParams(window.location.search);
  const isc = queryParams.get('isc') || '';
  const itc = queryParams.get('itc') || trackingCode;
  return {
    isc,
    itc
  };
};

/**
 * @method getImagesBaseUrl
 * @returns {String} images base url
 */
exports.getIscAndItc = getIscAndItc;
const getImagesBaseUrl = () => {
  const env = getEnv(window.location.host);
  const urlEnv = env === 'prod' ? '' : `${env}-`;
  return `https://img6.${urlEnv}wsimg.com/serpimg/img/solutionsimg/`;
};
exports.getImagesBaseUrl = getImagesBaseUrl;
const getUrlQueryParam = qpValue => {
  const paramValue = new URLSearchParams(window.location.search).get(qpValue);
  return typeof paramValue === 'string' ? paramValue.trim() : null;
};
exports.getUrlQueryParam = getUrlQueryParam;
const getTLD = domainName => {
  if (!domainName || !domainName.includes('.')) return '';
  const domainSplit = domainName.substr(domainName.indexOf('.') + 1);
  return domainSplit.length > 0 ? domainSplit?.trim() : '';
};
exports.getTLD = getTLD;